import { render, staticRenderFns } from "./AssetField.vue?vue&type=template&id=2af1544e&scoped=true"
import script from "./AssetField.vue?vue&type=script&lang=js"
export * from "./AssetField.vue?vue&type=script&lang=js"
import style0 from "./AssetField.vue?vue&type=style&index=0&id=2af1544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1544e",
  null
  
)

export default component.exports